import React from 'react';
import { Link } from 'react-router-dom';
import { Button, FormGroup, Input, Col, Row, Container, Table } from 'reactstrap';
import api from '../../api';
import ActionEdit from '../ActionEdit';
import './index.css';

export default class Segment extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            action: this.props.action || null,
            isEdit: false,
        };
    }
    getActionHistory() {
        const { action } = this.state;
        api.fetchAPI({
            method: 'get',
            uri: `action/${action.id}/notification/history`,
            body: action,
            success: (response) => {
                if (response.status == 'ok') {
                    this.setState({ action: response.action });
                } else {
                    alert(response.message);
                }
            },
            error: (error) => {
              console.error(error);
            }
        });
    }
    executeAction() {
        this.setState({ isLoading: true });
        const { action } = this.state;
        const confirmation = window.confirm(`Are you sure to run "${action.name}"?`);
        if (confirmation) {
            api.fetchAPI({
                method: 'post',
                uri: `action/${action.id}/execute`,
                body: action,
                success: (response) => {
                    if (response.status == 'ok') {
                        alert('Action has been submitted to run');
                    } else {
                        alert(response.message);
                    }
                    
                    this.setState({ isLoading: false });
                },
                error: (error) => {
                console.error(error);
                this.setState({ isLoading: false });
                }
            });
        } else {
            this.setState({ isLoading: false });
        }
    }
    deleteAction() {
        const confirmation = window.confirm('Are you sure to delete this action? This action cannot be undone');
        if (!confirmation) return;
        const { action } = this.state;
        api.fetchAPI({
            method: 'delete',
            uri: `actions`,
            body: action,
            success: (response) => {
                if (response.status == 'ok') {
                    this.setState({
                        action: null,
                    });
                } else {
                    alert(response.message);
                }
                
                this.setState({ isLoading: false });
            },
            error: (error) => {
              console.error(error);
              this.setState({ isLoading: false });
            }
        });
    }
    setSchedule() {
        const { action } = this.state;
        if (!action.schedule_cron_string) {
            alert('You must click Edit and define CRON string to schedule this action');
            return;
        }
        api.fetchAPI({
            method: 'post',
            uri: `action/${action.id}/schedule`,
            success: (response) => {
                if (response.status == 'ok') {
                    this.setState({
                        action: response.action,
                    });
                } else {
                    alert(response.message);
                }
                this.setState({ isLoading: false });
            },
            error: (error) => {
              console.error(error);
              this.setState({ isLoading: false });
            }
        });
    }
    disableSchedule() {
        const { action } = this.state;
        api.fetchAPI({
            method: 'delete',
            uri: `action/${action.id}/schedule`,
            success: (response) => {
                if (response.status == 'ok') {
                    this.setState({
                        action: response.action,
                    });
                } else {
                    alert(response.message);
                }
                this.setState({ isLoading: false });
            },
            error: (error) => {
              console.error(error);
              this.setState({ isLoading: false });
            }
        });
    }
    render() {
        const { action, isEdit, isLoading } = this.state;
        if (!action) return null;
        if (isEdit) return <ActionEdit isEdit action={action} />
        return (
            <div className="segment-container">
                <h5>{action.name}</h5>
                <p className="action-description">{action.description}</p>
                {action.stats &&
                    <div>
                        <div className="row">
                            <div className="col-md-6">
                                <p>Sent messages: {action.stats.sent_message_count} messages</p>
                            </div>
                            <div className="col-md-6">
                                <p>Users received: {action.stats.noti_received_count} users</p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <p>Sent users: {action.stats.sent_user_count} users</p>
                            </div>
                            <div className="col-md-6">
                                <p>Users read: {action.stats.user_read_count} users</p>
                            </div>
                        </div>
                    </div>
                }
                <Button className="action-button" color={isLoading ? 'secondary' : 'warning'} size="sm" disabled={isLoading} onClick={() => this.executeAction()}>
                    {isLoading ? 'Executing... Please wait...' : 'Execute'}
                </Button>
                <Button className="action-button" color="info" size="sm" onClick={() => this.setState({ isEdit: true })}>Edit</Button>
                <Button className="action-button" color="primary" size="sm" onClick={() => this.getActionHistory()}>View stats</Button>
                {!action.schedule_job_id ?
                    <Button className="action-button" color="warning" size="sm" onClick={() => this.setSchedule()}>Set schedule</Button>
                    :
                    <Button outline className="action-button" color="warning" size="sm" onClick={() => this.disableSchedule()}>Disable schedule</Button>
                }
                <Button className="action-button" color="danger" size="sm" onClick={() => this.deleteAction()}>Delete</Button>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Action/index.js